import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import { useParams } from "react-router-dom";
import { secondAxios } from "../../../../../api/axios";
import DocReviewer from "./DocReviewer";
import DocumentTransmittalTab from "./DocumentTransmittalTab";
import { useDCS } from "./Table/DCSContext";
import PlantTasksWrapper from "../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
import ProjectTasksPage from "../../../Project/allProjectsPage/ProjectsTable/ProjectTasksPage";
import PageHeader from "../../../../../components/PageHeader";

const DCSTab = ({ plant = false }) => {
  const { projectId, plantId, id } = useParams();
  const activeProjectId = projectId || id;
  const { documentList } = useDCS();
  const [plantName, setPlantName] = useState("");
  const [projectName, setProjectName] = useState("");

  useEffect(() => {
    if (!plant || !plantId) {
      setPlantName("");
      return;
    }
    secondAxios
      .get(`/plant/${plantId}`)
      .then((res) => setPlantName(res.data?.name || ""))
      .catch(() => setPlantName(""));
  }, [plant, plantId]);

  useEffect(() => {
    if (plant) {
      setProjectName("");
      return;
    }
    if (!activeProjectId) {
      setProjectName("");
      return;
    }
    secondAxios
      .get(`/project/${activeProjectId}`)
      .then((res) =>
        setProjectName(
          res.data?.name || res.data?.projectName || res.data?.title || "",
        ),
      )
      .catch(() => setProjectName(""));
  }, [plant, activeProjectId]);

  console.log("plant in dcs is :", plant);
  console.log("document list in dcs is :", documentList);

  // console.log({ projectId });
  const tabs = [
    // {
    //   label: "MRQ",
    //   panel: <DCSTable projectId={projectId || ""} type="MRQ" />,
    // },
    {
      label: "Doc. Reviewer",
      panel: <DocReviewer projectId={activeProjectId} plant={plant} />,
    },
    {
      label: "4D Schedule",
      panel: plant ? (
        <PlantTasksWrapper type={"engineering"} />
      ) : (
        <ProjectTasksPage catList={documentList} plant={plant} />
      ),
    },
    {
      label: "Doc. Transmittal",
      panel: <DocumentTransmittalTab />,
    },
    // {
    //   label: "RFI",
    //   panel: <DCSTable type="RFI" />,
    // },
    // {
    //   label: "Change Order",
    //   panel: <ChangeOrder type="Change Order" />,
    // },
    // {
    //   label: "Transmittal",
    //   panel: <DocumentTransmittalTab />,
    // },
  ];

  return (
    <Box>
      {plant ? (
        <PageHeader
          plant={{ id: plantId, name: plantName }}
          pageTitle="EMS (Engineering Management System)"
        />
      ) : (
        activeProjectId && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "space-between",
              px: 2,
              pt: 2,
              pb: 0,
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "primary.main",
                bgcolor: (theme) => `${theme.palette.primary.main}14`,
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                borderLeft: "4px solid",
                borderColor: "primary.main",
              }}
            >
              EMS (Engineering Management System)
            </Typography>
            {projectName && (
              <Typography
                variant="h6"
                color="primary.main"
                fontWeight={600}
                sx={{ ml: "auto", lineHeight: 1.3 }}
              >
                {projectName}
              </Typography>
            )}
          </Box>
        )
      )}
      <NavTabs tabs={tabs} navLabel="dcs-tab" />
    </Box>
  );
};

export default DCSTab;
